import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=b87b46c6"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports